<template>
  <div class="strategy-body" id="strategy">
    <div class="title">
      Wecobi’s strategy is about creating a sustainable ecosystem where business
      growth, consumer satisfaction, and environmental responsibility go hand in
      hand. This triple win sets us apart and underscores our commitment to
      shaping a future where commerce and sustainability are deeply intertwined.
    </div>
  </div>
</template>

<script>
export default {
  name: "Strategy",
};
</script>

<style scoped>
.strategy-body {
  width: 100%;
  height: 332px;
  padding: 80px 80px 120px 80px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
}

.title {
  font-size: 22px;
  font-weight: 400;
  text-align: center;
  max-width: 1004px;
}

@media (max-width: 1024px) {
  .strategy-body {
    height: 320px;
  }

  .title {
    font-size: 20px;
  }
}

@media (max-width: 744px) {
  .strategy-body {
    height: 328px;
  }
}

@media (max-width: 588px) {
  .strategy-body {
    height: 440px;
  }
}
@media (max-width: 431px) {
  .strategy-body {
    height: 430px;
    padding: 80px 40px;
  }
  .title {
    font-size: 18px;
  }
}
</style>
